var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoup2Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.5,
    height: 45.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF510D",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M-.001 0h45.002v45H-.001V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#222",
    d: "M22.5 2c11.322 0 20.499 9.178 20.499 20.5S33.822 43 22.5 43 2.001 33.822 2.001 22.5 11.178 2 22.5 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M33.542 27.51c-.194.196-.511.196-.708 0l-9.818-9.818-9.821 9.818c-.194.196-.51.196-.705 0-.196-.195-.196-.512 0-.707l9.906-9.906c-.017-.146.012-.295.125-.407.134-.135.324-.17.494-.119.17-.051.362-.016.497.119.113.112.141.261.124.408l9.906 9.905c.194.195.194.512 0 .707z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoup2Icon);
export default __webpack_public_path__ + "static/media/goup-2-icon.4cd2140ce1700f749d89676de878f16b.svg";
export { ForwardRef as ReactComponent };